export const configFlightPlanListDh = {
  "data": {
    "Type": "JSON",
    "Name": "FlightPlanList",
    "url": "%flightplan_api_url%/flightplan/get_flight_plan?usergroup_id=%usergroup_id%",
    "cache_busting": true,
    "retain": true,
    "update_interval": 60
  }
};
